export enum DaisieWordmarkColour {
  Black = 'black',
  White = 'white',
}
